import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import MedicalMeasures from './MedicalMeasures';
import ErrorFallback from 'FRONTEND/components/ErrorFallback';

import './index.css';

export default (element, store) => {
  const root = createRoot(element);
  root.render(
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Provider store={store}>
        <MedicalMeasures
          consultationDate={element.dataset.consultationDate}
          allDeviceExams={element.dataset.allDeviceExams ? JSON.parse(element.dataset.allDeviceExams) : {}}
          bloodPressureIcon={element.dataset.bloodPressureIcon}
          oximetryIcon={element.dataset.oximetryIcon}
          glucoseIcon={element.dataset.glucoseIcon}
          temperatureIcon={element.dataset.temperatureIcon}
          ecgIcon={element.dataset.ecgIcon}
          otherMedicalMeasurementIcon={element.dataset.otherMedicalMeasurementIcon}
        />
      </Provider>
    </ErrorBoundary>,
  );

  return () => {
    root.unmount();
  };
};
